import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import { DataOperation } from '../../data/DataOperation';
import { DataTypeProgramme } from '../../data/DataTypeProgramme';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxCertification } from '../ComboBox/ComboBoxCertification';
import { ComboBoxCompte } from '../ComboBox/ComboBoxCompte';
import { ComboBoxNatureChauffage } from '../ComboBox/ComboBoxNatureChauffage';
import { ComboBoxPerformanceEnergetique } from '../ComboBox/ComboBoxPerformanceEnergetique';
import { ComboBoxPrixMaitrise } from '../ComboBox/ComboBoxPrixMaitrise';
import { ComboBoxTVATaux } from '../ComboBox/ComboBoxTVATaux';
import { ComboBoxTypeChauffage } from '../ComboBox/ComboBoxTypeChauffage';
import { ComboBoxZoneFiscale } from '../ComboBox/ComboBoxZoneFiscale';
import { EUITextField } from '../EUI/EUITextField';
import { FicheIdentificationNomenclature } from '../Fiche/FicheIdentificationNomenclature';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { HintVerticalPosition, HintWrapper } from '../Outils/HintWrapper';
import { MessageBars } from '../Outils/MessageBars';
import { PickerCPVille } from '../Picker/PickerCPVille';
import './FicheIdentification.css';

/****************************************************************
 PROPS:
    onPeutChargerLeComposant : bool (==false => on ne charge pas le composant ; ==true => on charge)

    onAffichePanelIdentification : bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    onChange : méthode appelée si onAffichageSansPanel = true
    
****************************************************************/

var objetState = {
    operation: {},
    listOperationTVACas: [],
    nbResaValideesCG: 0,
    dateCommercialisation: '',

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    onActiveBoutonEnregistrer: false,

    titrePanel: 'Créer une opération'
};

export class FicheIdentification extends Component {

    _creationContent = () => {

        const { listOperationTVACas, operation } = this.state;

        return <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-xl6">
                    <EUITextField
                        data-testid="divNomOperation"
                        label="Nom de l'opération"
                        maxLength={MaxLengths.operation.nomOperation}
                        onDelayedChange={(event, newValue) => this._onMiseAJourChamp("operation", "nomOperation", newValue)}
                        required
                        value={operation.nomOperation}
                    />
                    <EUITextField
                        data-testid="divNomCommercial"
                        label="Nom commercial"
                        maxLength={MaxLengths.operation.nomCommercial}
                        onDelayedChange={(event, newValue) => this._onMiseAJourChamp("operation", "nomCommercial", newValue)}
                        required
                        value={operation.nomCommercial}
                    />
                    <EUITextField
                        data-testid="divAdresse"
                        label="Adresse"
                        maxLength={MaxLengths.operation.adresse}
                        onDelayedChange={(event, newValue) => this._onMiseAJourChamp("operation", "adresse", newValue)}
                        required
                        value={operation.adresse}
                    />
                    <EUITextField
                        data-testid="divComplementAdresse"
                        label="Complément d'adresse"
                        maxLength={MaxLengths.operation.complementAdresse}
                        onDelayedChange={(event, newValue) => this._onMiseAJourChamp("operation", "complementAdresse", newValue)}
                        value={operation.complementAdresse}
                    />
                    <PickerCPVille
                        data-testid="divCPVille"
                        cp={operation.cp}
                        onChange={(idVilleAdm, idDeptAdm, idRegionAdm, cp, ville) => this._onMiseAJourChampCPVille(idVilleAdm, idDeptAdm, idRegionAdm, ville, cp)}
                        required
                        villeAdministrative={operation.ville}
                    />
                    <ComboBoxCompte
                        data-testid="divLoginContactEI"
                        avecValeurDefaut={false}
                        disabled={!(operation.idRegion > 0 && operation.idAgence > 0)}
                        idAgence={operation.idAgence}
                        idRegion={operation.idRegion}
                        idSociete={1}
                        label="Contact EI"
                        onChange={(event, option) => this._onMiseAJourChamp("operation", "loginContactEI", option.key)}
                        required
                        selectedKey={operation.loginContactEI}
                    />
                    <ComboBoxCompte
                        data-testid="divResponsableProgramme"
                        avecValeurDefaut={false}
                        idAgence={operation.idAgence}
                        idRegion={operation.idRegion}
                        idSociete={1}
                        label="Responsable programme"
                        onChange={(event, option) => this._onMiseAJourChamp("operation", "responsableProgramme", option.key)}
                        required
                        selectedKey={operation.responsableProgramme}
                    />
                    <HintWrapper
                        content={<span>Attention, les réservations passées nécessitent un envoi manuel de mail d'ouverture de l'espace client via la tuile \"Back Office Espace Client"\</span>} //2378
                        verticalAlign={HintVerticalPosition.bottom}
                        verticalOffset={5}
                    >
                        <Toggle
                            data-testid="divActivationCapsuleClient"
                            label="Activation de l'espace client"
                            checked={operation.activationCapsuleClient}
                            onText="Oui"
                            offText="Non"
                            onChange={(e, isChecked) => this._onMiseAJourChamp("operation", "activationCapsuleClient", isChecked)}
                        />
                    </HintWrapper>
                </div>

                <div className="ms-Grid-col ms-sm12 ms-xl6">
                    {operation.idOperation > 0 &&
                        <Fragment>
                            <div className="titreEncart">Energétique</div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md6" name="divPerformanceEnergetique">
                                    <ComboBoxPerformanceEnergetique
                                        onChange={(event, option) => this._onMiseAJourChamp("operation", "idPerformanceEnergetique", option.key)}
                                        selectedKey={operation.idPerformanceEnergetique}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-md6" name="divCertification">
                                    <ComboBoxCertification
                                        onChange={(event, option) => this._onMiseAJourChamp("operation", "idCertification", option.key)}
                                        selectedKey={operation.idCertification}
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-md6" name="divTypeChauffage">
                                    <ComboBoxTypeChauffage
                                        onChange={(event, option) => this._onMiseAJourChamp("operation", "idTypeChauffage", option.key)}
                                        selectedKey={operation.idTypeChauffage}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-md6" name="divNatureChauffage">
                                    <ComboBoxNatureChauffage
                                        onChange={(event, option) => this._onMiseAJourChamp("operation", "idNatureChauffage", option.key)}
                                        selectedKey={operation.idNatureChauffage}
                                    />
                                </div>
                            </div>
                            <EUITextField
                                data-testid="divSyndicCoPro"
                                label="Syndic de copropriété"
                                maxLength={MaxLengths.operation.syndicCoPro}
                                onDelayedChange={(event, newValue) => this._onMiseAJourChamp("operation", "syndicCoPro", newValue)}
                                value={operation.syndicCoPro}
                            />
                            <EUITextField
                                data-testid="divNumeroCompte"
                                label="N° de compte"
                                maxLength={MaxLengths.operation.numeroCompte}
                                onDelayedChange={(event, newValue) => this._onMiseAJourChamp("operation", "numeroCompte", newValue)}
                                value={operation.numeroCompte}
                            />
                        </Fragment>
                    }

                    {!operation.idOperation &&
                        <Fragment>
                            <div className="ms-Grid-col ms-sm12 titreEncart">Nomenclature</div>
                            <FicheIdentificationNomenclature
                                onAffichageSansPanel
                                onChange={(nomPropriete, valeur) => this._onMiseAJourChamp("operation", nomPropriete, valeur)}
                            />
                        </Fragment>
                    }

                    <div className="separateurGrand"></div>
                    <div className="titreEncart">Fiscalité</div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md6" name="divCasTVA">
                            <ComboBoxTVATaux
                                disabled={!operation.idProduit || !operation.idSousProduit}
                                idProduit={operation.idProduit}
                                idSousProduit={operation.idSousProduit}
                                multiSelect
                                onChange={(event, option, _, value, item) => {
                                    const index = listOperationTVACas.findIndex(tva => tva.idTVACas === option.key);
                                    let newListOperationTVACas = [...listOperationTVACas];

                                    if (option.selected && index === -1) { // Ajout
                                        const { idOperation } = operation;
                                        const ordre = newListOperationTVACas.length + 1;
                                        newListOperationTVACas.push({ ...item, idOperation, ordre });
                                    }

                                    else { // Suppression
                                        const tvaSupprimee = newListOperationTVACas.splice(index, 1)[0];
                                        newListOperationTVACas = newListOperationTVACas.map(tva => {
                                            if (tva.ordre <= tvaSupprimee.ordre) return tva;
                                            else return { ...tva, ordre: tva.ordre - 1 };
                                        });
                                    }

                                    this.setState({ listOperationTVACas: newListOperationTVACas }, this._onVerificationFormulaire)
                                }}
                                onClickDown={newSelectedKey => this.setState({ listOperationTVACas: newSelectedKey }, this._onVerificationFormulaire)}
                                onClickUp={newSelectedKey => this.setState({ listOperationTVACas: newSelectedKey }, this._onVerificationFormulaire)}
                                required
                                selectedKey={listOperationTVACas}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md6" name="divZoneFiscale">
                            <ComboBoxZoneFiscale
                                onChange={(event, option) => this._onMiseAJourChamp("operation", "zoneFiscale", option.key)}
                                selectedKey={operation.zoneFiscale}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md6">
                            <div className="ms-Grid my-1" dir="ltr">
                                {!!listOperationTVACas && Array.isArray(listOperationTVACas) &&
                                    listOperationTVACas.map((operationTVACas, index) =>
                                        <div key={index} className="ms-Grid-row">
                                            <div className="ms-Grid-col ms-sm4">{index === 0 ? "Choix principal :" : `${index + 1}ème choix :`}</div>
                                            <div className="ms-Grid-col ms-sm8">{operationTVACas.tvaCas}</div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md6" name="divPrixMaitrise">
                            <ComboBoxPrixMaitrise
                                onChange={(event, option) => this._onMiseAJourChamp("operation", "idPrixMaitrise", option.key)}
                                required
                                selectedKey={operation.idPrixMaitrise}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>;

    };

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit = () => {
        this.setState(objetState);
    }

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement de l\'opération en cours'
        });

        var chargementFicheIdentification = DataOperation._chargementFicheIdentification();

        chargementFicheIdentification.then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

            if (retourVerif === null) {
                let retourData = responseFetch.reponseAPIobjet;
                let stateTemp = {};

                if (retourData !== null) {
                    stateTemp.operation = retourData[0];
                    stateTemp.listOperationTVACas = retourData[7] || [];
                    stateTemp.nbResaValideesCG = retourData[16];
                    stateTemp.titrePanel = 'Modifier l\'opération';
                    stateTemp.dateCommercialisation = retourData[29];
                }

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onVerificationFormulaire);
            }
            else {
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            }
        });
    }

    _chargementTypeProgramme(idProduit) {
        var getTypeProgramme = DataTypeProgramme._getTypeProgramme(idProduit);

        getTypeProgramme.then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

            if (retourVerif === null) {
                let retourData = responseFetch.reponseAPIobjet;

                if (retourData !== null) {
                    let typeProgrammeTrav = retourData;
                    Scriba.state().setObjetPropriete(this, 'operation', 'idTypeProgramme', typeProgrammeTrav.idTypeProgramme, this._onVerificationFormulaire);
                }
                else {
                    Scriba.state().setObjetPropriete(this, 'operation', 'idTypeProgramme', null, this._onVerificationFormulaire);
                }
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
            }
        });
    }

    _onEnregistrement = () => {

        const { operation, listOperationTVACas } = this.state;

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement de l\'opération en cours'
        });

        let enregistrementOperation = DataOperation._onEnregistrementOperation(operation, listOperationTVACas);

        enregistrementOperation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                    this.props.onEnregistrementFiche();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onOpen = () => {
        if (this.props.estCreation !== true) {
            this._chargementDonnees();
        }
    }

    _onRenderFooterContent = () => {
        let boutonActif = this.state.onActiveBoutonEnregistrer;

        return (
            <div>
                <PrimaryButton name="btnEnregistrerOperation" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!boutonActif}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onMiseAJourChamp = (nomObjet, nomPropriete, valeur) => {
        // KP - 29/09/2022 - Si sélection d'un idProduit alors reset de la valeur de l'idSousProduit
        if (nomPropriete === "idProduit") {
            let objet = { ...this.state[nomObjet] };
            objet.idProduit = valeur;
            objet.idSousProduit = 0;
            const state = { [nomObjet]: objet, listOperationTVACas: [] };
            this.setState(state, this._onVerificationFormulaire);
            this._chargementTypeProgramme(valeur);
        }
        else if (nomPropriete === "idSousProduit") {
            let objet = { ...this.state[nomObjet] };
            objet.idSousProduit = valeur;
            const state = { [nomObjet]: objet, listOperationTVACas: [] };
            this.setState(state, this._onVerificationFormulaire);
        }
        else Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);
    };

    _onMiseAJourChampNombre = (nomObjet, nomPropriete, valeur) => {
        Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, nomObjet, nomPropriete, valeur, 'fr', this._onVerificationFormulaire)
    }

    _onMiseAJourChampCPVille(idVilleAdministrative, idDepartementAdministratif, idRegionAdministrative, villeAdministrative, cp) {
        let operationTrav = { ...this.state.operation };
        operationTrav.idVilleAdministrative = idVilleAdministrative;
        operationTrav.idDepartementAdministratif = idDepartementAdministratif;
        operationTrav.idRegionAdministrative = idRegionAdministrative;
        operationTrav.ville = villeAdministrative;
        operationTrav.cp = cp;

        this.setState({
            operation: operationTrav
        }, this._onVerificationFormulaire);
    }

    _onVerificationFormulaire = () => {
        const { operation, listOperationTVACas } = this.state;
        Immocom.fiche()._validationFormulaire(this, 'Operation', { ...operation, listOperationTVACas }, (this.state.operation.idOperation > 0 ? 'Modification' : 'Création'));
    }

    render = () => {
        let content = this._creationContent();

        if (this.props.onAffichageSansPanel) {
            return content;
        }
        else {
            return <Panel
                isOpen={this.props.onAffichePanelIdentification}
                headerText={this.state.titrePanel}
                type={PanelType.large}
                onDismiss={this._onAnnulation}
                onOpen={this._onOpen}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                {content}

            </Panel>;
        }
    }
}